import { TeamsContextWithCredential, useTeamsUserCredential } from '@microsoft/teamsfx-react';

import config from 'src/configs/config';

const useTeamsFx = (): TeamsContextWithCredential => {
  const teamsfx: TeamsContextWithCredential = useTeamsUserCredential({
    initiateLoginEndpoint: config.initiateLoginEndpoint!,
    clientId: config.clientId!,
  });

  return teamsfx;
};

export default useTeamsFx;
